export const config = {
  state: {
    config: {},
  },
  mutations: {
  },
  actions: {
  },
};
